import React from 'react'
import { useTitle } from 'react-use'

import { useCurrentApplication } from '~/hooks/useCurrentApplication'
import { exists } from '~/utils'

export const AppRoot = () => {
  const currentApplication = useCurrentApplication()

  useTitle(currentApplication?.name ?? '9segs')

  if (exists(currentApplication)) {
    return <currentApplication.Root />
  }

  // TODO: Not Found
  return <div>Not Found</div>
}
